import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useDeleteLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (qualifierId: string) =>
      await request(`${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers/${qualifierId}`, {
        method: "DELETE",
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "rule.delete.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
